/* Progressive enhancement only: Shopify GET, filtering, sorting and pagination remain native. */
(() => {
  if (window.tbCollectionsReady) return;
  window.tbCollectionsReady = true;
  const isPage = key => key === 'page' || key.startsWith('page_') || key === 'section_id';
  function init(root) {
    root.querySelectorAll('[data-tb-collection-filters]').forEach(wrapper => {
      const form = wrapper.querySelector('form');
      if (!form || form.dataset.tbReady) return;
      form.dataset.tbReady = 'true';
      form.addEventListener('formdata', event => {
        const current = new URLSearchParams(window.location.search);
        const controlled = new Set(Array.from(form.elements, element => element.name));
        // Unchecked managed facets stay absent; unrelated query parameters survive.
        for (const key of new Set(current.keys())) {
          if (!isPage(key) && !controlled.has(key)) {
            for (const value of current.getAll(key)) event.formData.append(key, value);
          }
        }
        for (const [key, value] of Array.from(event.formData.entries())) {
          if (isPage(key) || (key.startsWith('filter.') && value === '')) event.formData.delete(key);
        }
      });
      wrapper.querySelectorAll('[data-tb-reset]').forEach(link => {
        const url = new URL(link.href);
        const current = new URLSearchParams(window.location.search);
        for (const key of new Set(current.keys())) {
          if (!isPage(key) && !key.startsWith('filter.') && !url.searchParams.has(key)) {
            for (const value of current.getAll(key)) url.searchParams.append(key, value);
          }
        }
        link.href = url.pathname + url.search;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
